import { API } from "@/services"

export const PINCODES_ENDPOINTS = {
  list(params={}){
    return API.Axios.central_point.v1.request({
      url: `pincodes`,
      method: 'GET',
      params,
    })
  },
  add(data={}){
    return API.Axios.central_point.v1.request({
      url: `pincodes`,
      method: 'POST',
      data,
    })
  },
  remove(pincode_id,data={}){
    return API.Axios.central_point.v1.request({
      url: `pincodes/${pincode_id}`,
      method: 'DELETE',
      data,
    })
  },
  update(pincode_id,data={}){
    return API.Axios.central_point.v1.request({
      url: `pincodes/${pincode_id}`,
      method: 'PUT',
      data,
    })
  },
  get(pincode_id,params={}){
    return API.Axios.central_point.v1.request({
      url: `pincodes/${pincode_id}`,
      method: 'GET',
      params,
    })
  },
}